import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiChevronDown, FiHelpCircle, FiMessageCircle, FiSmile } = FiIcons;

export default function GuideQuestionCard({ item, index }) {
  const [expanded, setExpanded] = useState(index === 0);

  return (
    <div className={`guide-q-card ${expanded ? 'is-active' : ''}`}>
      <button
        type="button"
        className="guide-q-header"
        onClick={() => setExpanded(!expanded)}
        aria-expanded={expanded}
      >
        <div className="guide-q-icon-pill">
          <SafeIcon icon={FiHelpCircle} />
        </div>
        <span className="guide-q-title">{item.question}</span>
        <div className={`guide-chevron ${expanded ? 'rotated' : ''}`}>
          <SafeIcon icon={FiChevronDown} />
        </div>
      </button>

      {expanded && (
        <div className="guide-q-body">
          <div className="prompt-block">
            <div className="prompt-label">
              <SafeIcon icon={FiSmile} />
              <span>Prompt for Little Readers:</span>
            </div>
            <p className="prompt-text">“{item.promptForKids}”</p>
          </div>

          <div className="prompt-block tip-block">
            <div className="prompt-label tip-label">
              <SafeIcon icon={FiMessageCircle} />
              <span>Educator & Parent Guide Note:</span>
            </div>
            <p className="prompt-text">{item.teacherTip}</p>
          </div>
        </div>
      )}
    </div>
  );
}
